module.exports = "data:image/gif;base64,R0lGODlhHwAQAMQAAAAAAP///wDKDQB6CQClCBmpHxmlICWrLDu+Qj+xRn25gAHJBia+KyWMKDq1PkzKUE61Ub7avxmlGibKKEy+TFmxWVCeUF+yX77avnPKcnKxcVayU7DPr////wAAAAAAACH5BAEAAB0ALAAAAAAfABAAAAVXYCeOZGmeaKqubDtem+tW2WPIbPJMhDiMvx+uA0EICj6hcNiJMBaYpK+jVE6t1I7jAMwGs97rNKvQdKnfgfobTos4Z3U4PgZTJOf5OokFWxpMgYKDhIMhADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/newDocument_NL.gif
// module id = XwLR
// module chunks = 1